import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { APP_CONFIG } from "../../config/config";
import { AppConfig } from "../../config/config.type";
import { AbstractRepository } from "../../shared/repositories/abstract.repository";
import { ContentReaction } from "../models/content-reactions.entity";
import { IContentView } from "../models/content-views.entity";

@Injectable()
export class ContentViewsRepository extends AbstractRepository<IContentView> {
    constructor(
        @Inject(APP_CONFIG)
        private readonly appConfig: AppConfig,
        protected override readonly http: HttpClient
      ) {
        super(http, ContentReaction);
        this.apiUrl = this.appConfig.apiUrl;
      }
    
    getEntityName(): string {
        return "content-views";
    }

    createContentView(payload: { contentId: string }): Observable<any> {
        return this.http.post([ this.apiUrl, this.getEntityName() ].join('/'), payload);
    }
    
    hasUserViewedContent(contentId: string): Observable<boolean> {
        return this.http.get<boolean>([ this.apiUrl, this.getEntityName(), contentId, 'check' ].join('/'));
    }
}